module.exports = __webpack_public_path__ + "img/edit-profile-pic.366a3c5a.svg";